import React, { useState, useCallback, useEffect, useContext } from 'react';
import {
  Route,
  Routes,
  useLocation,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import { useCookies } from 'react-cookie';
import './App.css';

import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';

import api from '../../Utils/Api';
import * as Auth from '../../Utils/Auth';

import Header from '../Header/Header';
import MainPage from '../MainPage/MainPage';
import Performance from '../Performance/Performance';
import Theme from '../Theme/Theme';
import Profile from '../Profile/Profile';
import Test from '../Test/Test';
import CourseRoadMap from '../CourseRoadMap/CourseRoadMap';
import LoginPage from '../LoginPage/LoginPage';
import RegisterPage from '../RegisterPage/RegisterPage';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import CurrentTasks from '../CurrentTasks/CurrentTasks';
import Resource from '../Resources/Resource';
import TestResults from '../TestResults/TestResults';
import Exercise from '../Exercise/Exercise';
import Lesson from '../Lesson/Lesson';
import LockedResource from '../ErrorPages/LockedResource/LockedResource';
import AnswersUnchecked from '../ErrorPages/AnswersUnchecked/AnswersUnchecked';
import Alert from './Common/Alert/Alert';

import Popup from '../App/Common/Popup/Popup';
import Stream from '../Stream/Stream';
import NotificationsPage from '../NotificationsPage/NotificationsPage';
import BookingPage from '../BookingPage/BookingPage';
import BookingRequest from '../BookingPage/BookingRequest/BookingRequest';

import Calendar from '../Calendar/Calendar';
import Courses from '../Courses/Courses';
// import testUser from '../../TestData/TestUser.json'

function App() {
  const [cookies, setCookie, removeCookie] = useCookies(['token']);

  const [token, setToken] = useState(cookies.token ? cookies.token : undefined);
  const [user, setUser] = useState(undefined);
  const [isLoggedIn, setIsLoggedIn] = useState(cookies.token ? true : false);
  const [courses, setCourses] = useState(undefined);
  const [currentPlace, setCurrentPlace] = useState({});
  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const [streams, setStreams] = useState([]);
  const [courseName, setcourseName] = useState(undefined);
  const [showPopup, setshowPopup] = useState(true);
  const [streamCounter, setStreamCounter] = useState(0);
  const [noGroupsAssigned, setNoGroupsAssigned] = useState(false);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  let timer;

  useEffect(() => {
    // console.log(token)
    if (isLoggedIn) {
      Promise.all([
        api.getCourses(token),
        api.getUser(token),
        api.getStreams(token),
      ])

        .then(([courses, user, streams]) => {
          setCourses(courses);
          setUser(user);
          setStreams(streams);
        })
        .catch((e) => {
          // console.log(e);
          if (e == 401) {
            setIsLoggedIn(false);
            removeCookie('token');
            setToken(undefined);
            navigate('/login', { replace: true });
          }
          if (e == 417) {
            console.log('417');
            setIsLoggedIn(false);
            setNoGroupsAssigned(true);
            removeCookie('token');
            setToken(undefined);
            navigate('/login', { replace: true });
          }
        });
    }
  }, [isLoggedIn]);

  useEffect(() => {
    // console.log(token)
    if (!token) {
      setIsLoggedIn(false);
      removeCookie('token');
    }
  }, [token]);

  useEffect(() => {
    setcourseName(currentStreamCourseName());
    setshowPopup(true);
  }, [streams]);

  useEffect(() => {
    if (isLoggedIn && streamCounter < 20 && streams.length === 0)
      updateStreams();
    return () => clearInterval(timer);
  }, [isLoggedIn, streams, streamCounter]);

  const updateStreams = () => {
    timer =
      !timer &&
      setInterval(() => {
        setStreamCounter(streamCounter + 1);
        api
          .getStreams(token)
          .then(function (response) {
            if (!Array.isArray(response)) {
              return;
            }
            if (
              JSON.stringify(streams) !== JSON.stringify(response) &&
              !location.pathname.includes('/stream')
            )
              setStreams(response);
          })
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
          });
      }, 60000);
  };

  const handleCalendarClick = () => {
    setIsCalendarVisible(!isCalendarVisible);
  };

  const currentStreamCourseName = () => {
    if (streams && streams.length > 0)
      return (
        courses?.filter((c) => {
          return c.id === streams[0].course_id;
        })[0]?.title ?? ''
      );
    else return '';
  };
 
  async function handleLogIn(token, password) {
    setIsLoggedIn(true);
    setCookie('token', token, { maxAge: 60 * 60 * 1000 });
    navigate('/', { replace: true });
    setToken(token);
    /* Auth.authorize(login, password)
           .then((res) => {
             if (res) {
               // console.log(res)
               setIsLoggedIn(true);
               setCookie('token', res.access, { maxAge: 60 * 60 * 1000 });
               navigate('/', { replace: true });
               setToken(res.access);
             }
           })
           .catch((e) => {
             console.log(e);
           });*/
  }
  const handleLogOut = () => {
    Auth.logOut();
    setIsLoggedIn(false);
    removeCookie('token');
    navigate('/login', { replace: true });
    setToken(undefined);
  };

  const onClose = () => {
    setNoGroupsAssigned(false);
    setshowPopup(false);
  };

  const onStreamClick = () => {
    navigate('/stream/' + streams[0].id, { replace: true });
  };

  return (
    <CurrentUserContext.Provider
      value={{ user, setUser, isLoggedIn, setIsLoggedIn, token, setToken }}
    >
      <JourneyContext.Provider
        value={{ currentPlace, setCurrentPlace, breadCrumbs, setBreadCrumbs }}
      >
        <div className='App'>
          {' '}
          {isLoggedIn && streams && streams.length > 0 && showPopup && (
            <Alert
              title={'Началась онлайн-трансляция урока'}
			  description={courseName}
              onClickAction={onStreamClick}
              alertType={'info'}

            />
          )}
          {!isLoggedIn && showPopup && noGroupsAssigned && (
            <Popup
              title={'Вход временно невозможен'}
              onClose={onClose}
              noButton={true}
              color={'#7A5AF8'}
            >
              <div className='lockedResource__body'>
                {' '}
                Ожидайте назначения вам группы или свяжитесь с менеджером{' '}
              </div>{' '}
            </Popup>
          )}{' '}
          {isLoggedIn && 
          <>
          <Header logOut={handleLogOut} onCalendarClick={handleCalendarClick} breadCrumbs={breadCrumbs} isCalendarVisible={isCalendarVisible}/>
          {isCalendarVisible && <Calendar courses={courses} />}
        </>

          }
          <Routes>
            {' '}
            {/* <Route index
                                element={<LoginPage  logIn={handleLogIn} />} /> */}{' '}
            <Route
              path='/login'
              element={
                <LoginPage logIn={handleLogIn} isLoggedin={isLoggedIn} />
              }
            />{' '}
            <Route
              path='/register'
              element={
                <RegisterPage logIn={handleLogIn} isLoggedin={isLoggedIn} />
              }
            />{' '}
            <Route
              path='/'
              element={
                <ProtectedRoute>
                  <MainPage courses={courses} />{' '}
                </ProtectedRoute>
              }
            />
            <Route
              path='/notifications'
              element={
                <ProtectedRoute>
                  <NotificationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path='/performance'
              element={
                <ProtectedRoute>
                  <Performance />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/performance/:id'
              element={
                <ProtectedRoute>
                  <Performance />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/current'
              element={
                <ProtectedRoute>
                  <CurrentTasks courses={courses} />{' '}
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/lesson/:id'
              element={
                <ProtectedRoute>
                  <Lesson courses={courses} />{' '}
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/theme/:id'
              element={
                <ProtectedRoute>
                  <Theme />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/profile'
              element={
                <ProtectedRoute>
                  <Profile courses={courses} />{' '}
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/test/:id'
              element={
                <ProtectedRoute>
                  <Test />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/test/:id/result'
              element={
                <ProtectedRoute>
                  <TestResults />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/test/:id/best_result'
              element={
                <ProtectedRoute>
                  <TestResults bestOnly />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/exercise/:id'
              element={
                <ProtectedRoute>
                  <Exercise />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/course/:id'
              element={
                <ProtectedRoute>
                  <CourseRoadMap />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/courses/course/:id'
              element={
                <ProtectedRoute>
                  <CourseRoadMap />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/resource/:id'
              element={
                <ProtectedRoute>
                  <Resource />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/locked_resource'
              element={
                <ProtectedRoute>
                  <LockedResource />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/wait_for_result'
              element={
                <ProtectedRoute>
                  <AnswersUnchecked />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path='/stream/:id'
              element={
                <ProtectedRoute>
                  <Stream courses={courses} />
                </ProtectedRoute>
              }
            />{' '}
              <Route
              path='/booking'
              element={
                <ProtectedRoute>
                    <BookingPage></BookingPage>
                </ProtectedRoute>
              }
            />
            <Route
              path='/booking/request'
              element={
                <ProtectedRoute>
                    <BookingRequest />
                </ProtectedRoute>
              }
            />
             <Route
              path='/courses'
              element={
                <ProtectedRoute>
                    <Courses courses={courses}/>
                </ProtectedRoute>
              }
            />
          </Routes>{' '}
        </div>{' '}
      </JourneyContext.Provider>{' '}
    </CurrentUserContext.Provider>
  );
}

export default App;
